import { render } from "./EditarCliente.vue?vue&type=template&id=51f27949"
import script from "./EditarCliente.vue?vue&type=script&lang=js"
export * from "./EditarCliente.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__